import React, { Component } from "react";

import { auth, database } from "../../firebase";

export default class StepOne extends Component {
  state = {
    subjects: [
      "Mathematics",
      "Science & Tech.",
      "Painting",
      "Home Science",
      "Geography",
      "Data Entry Operations",
      "Chemistry",
      "Physics",
      "Library and Information Science",
      "Mass Communication",
      "Biology",
      "Computer Science",
      "Environmental Science",
      "Social Science",
      "Economic",
      "Business Studies",
      "Psychology",
      "Indian Culture & Heritage",
      "Hindi",
      "English",
      "Sanskrit",
      "Economic",
      "Commerce/Business Studies",
      "History",
      "Political Science",
      "Accountancy",
      "Introduction to Law"
    ],
    subject:[],
    selectedSubject: []
  };

  componentDidMount(){
    database.collection("subject_master").get().then((querySnapshot) => {
      var subject = []
      querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          subject.push(doc.data());
      });
      this.setState({subject:subject})
    });
  }
  cardSelect = e => {
    var selectedSubject = this.state.selectedSubject;
    const allCards = document.querySelectorAll(".card-selector");
    let subject;

    if (e.target.classList.contains("selected")) {
      e.target.classList.remove("selected");
      for (let i = 0; i < selectedSubject.length; i++) {
        if (selectedSubject[i] == e.target.innerHTML) {
          selectedSubject.splice(i, 1);
        }
      }
    } else {
      e.target.classList.add("selected");
      subject = e.target.innerHTML;
    }

    selectedSubject.push(subject);
    this.setState({ selectedSubject: selectedSubject });
    this.props.selectSubject(selectedSubject);
  };

  render() {
    return (
      <div className="step-item container">
        <div className="row d-flex">
          {this.state.subject.map((subject, key) => {
            return (
              <div
                key={key}
                id={subject.subject_id}
                class="p-2 m-1 card card-selector mini"
                onClick={this.cardSelect}
              >
                {subject.subject_name}
              </div>
            );
          })}

          {/* <div className="col-md-4 my-3">
              <div
                id="Beginner"
                className="card card-selector card-body text-center"
                onClick={this.cardSelect}
              >
                <i class="fa fa-paper-plane" />
                <h6>Beginner</h6>
                <p className="blockquote-footer m-0">Just starting out.</p>
              </div>
            </div>
            <div className="col-md-4 my-3">
              <div
                id="Intermediate"
                className="card card-selector card-body text-center"
                onClick={this.cardSelect}
              >
                <i class="fa fa-plane" />
                <h6>Intermediate</h6>
                <p className="blockquote-footer m-0">Starting to speak.</p>
              </div>
            </div>
            <div className="col-md-4 my-3">
              <div
                id="Advanced"
                className="card card-selector card-body text-center"
                onClick={this.cardSelect}
              >
                <i class="fa fa-rocket" />
                <h6>Advanced</h6>
                <p className="blockquote-footer m-0">Quite fluent.</p>
              </div>
            </div> */}
        </div>
      </div>
    );
  }
}
